import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityAttendanceAttendantReadAction from './legalEntityAttendanceAttendantRead.action.json' assert { type: 'json' }

const legalEntityAttendanceAttendantReadDefinition = defineReadAutoAction(
  legalEntityAttendanceAttendantReadAction,
  'legalEntityAttendanceAttendant',
)

export default legalEntityAttendanceAttendantReadDefinition
